import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_SALESFORCE } from './constants';
import { verifySalesforce } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* saveSalesforceCode({ payload, metadata }) {
  const token = readToken();
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/salesforce',
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });

    triggerNotification({
      title: 'Salesforce integrated successfully!',
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifySalesforce.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifySalesforce.error(errorMessage));
  }
}

export default function* salesforceVerify() {
  yield takeLatest(VERIFY_SALESFORCE.START, saveSalesforceCode);
}
